export const CHECKOUT_URL =
  'https://horse-riding-instructor-ready.impultienda.ar/checkout'

export const PRODUCT_NAME = 'Horse Riding Instructor Ready'

export const CTA_LABEL = '🟡 GET THE COMPLETE 6-IN-1 TEACHING SYSTEM NOW'

export const PRICE = 27.0

export function trackInitiateCheckout() {
  if (typeof window === 'undefined') return
  const fbq = (window as unknown as { fbq?: (...args: unknown[]) => void }).fbq
  if (!fbq) return
  fbq('track', 'InitiateCheckout', {
    content_name: 'Horse Riding Instructor Ready — Complete 6-in-1 System',
    value: PRICE,
    currency: 'USD',
  })
}
